module.exports = __webpack_public_path__ + "static/to-do-web-app-cover-950cafd09436bfee657a89d95660dd7c.png";